import { AGENCY } from "@/lib/agency";
import { Icon } from "@/components/Icon";

type Props = {
  applyHref?: string;
};

/**
 * Bottom-of-viewport action bar shown only on small screens.
 * Reused across product pages so visitors always have one-tap call & apply.
 */
export function MobileStickyBar({ applyHref = "/apply-funding" }: Props) {
  return (
    <>
      {/* Spacer so content isn't hidden behind the bar */}
      <div aria-hidden className="h-16 md:hidden" />
      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 px-3 py-2 backdrop-blur supports-[backdrop-filter]:bg-background/80 md:hidden">
        <div className="mx-auto flex max-w-md items-center gap-2">
          <a
            href={AGENCY.phoneHref}
            className="flex flex-1 items-center justify-center gap-2 rounded-full border border-border bg-background px-4 py-2.5 text-sm font-semibold text-foreground"
          >
            <Icon name="phonecall" color="bl" className="h-4 w-4"  /> Call
          </a>
          <a
            href={applyHref}
            className="flex flex-1 items-center justify-center gap-2 rounded-full bg-accent px-4 py-2.5 text-sm font-semibold text-accent-foreground"
          >
            Apply Now
          </a>
        </div>
      </div>
    </>
  );
}
